var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Tooltip, { TooltipPlacement } from "../Tooltip/Tooltip";
var CardTooltip = function (props) {
    return (_jsx("div", __assign({ "data-testid": "tooltip-wrapper" }, { children: _jsx(Tooltip, __assign({ content: props.tooltip, placement: props.placement || TooltipPlacement.Bottom }, { children: props.questionIcon })) })));
};
export default CardTooltip;
